<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Resumos diários</v-toolbar-title>
                    <v-btn flat to="/criar-diario" outline color="white"  style="position:absolute; right:20px; top:7px">Novo</v-btn>
                </v-toolbar>

                <v-layout row wrap>
                    <v-flex xs11 sm5>
                        <v-menu
                        lazy
                        :close-on-content-click="false"
                        v-model="menu"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        >
                        <v-text-field
                            slot="activator"
                            label="Data"
                            v-model="date"
                            prepend-icon="event"
                            readonly
                        ></v-text-field>
                        <v-date-picker v-model="date" no-title scrollable actions>
                            <!--template scope="{ save, cancel }"-->
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <!--v-btn flat color="primary" @click="cancel">Cancel</v-btn-->
                                <v-btn class="buttonOk" flat color="primary" @click="save">OK</v-btn>
                            </v-card-actions>
                            <!--/template-->
                        </v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                <v-flex v-for="(item, index) in items" xs12 sm6 md4 row style="margin-bottom:5px; padding:0px">
                    
                    <v-card>
                    
                        <v-card-text>
                            <v-btn class="deletar" v-if="slugAutor == slugLogado" flat color="orange" flat="flat" @click="deletarItem(item.slug)"><img :src="lixeira" class="lixeira" /></v-btn>
                            <v-card-title primary-title>
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                <div class="imagem" v-bind:style="{ 'background-image': 'url(' + item.imagem + ')' }" ></div>
                                <div style="width:66%" class="body-content">
                                    
                                    <h3 class="headline mb-0" :title="item.nome">{{item.nome}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                    <div><b>Entrada:</b> {{item.entrada}} e <b>Saída:</b> {{item.saida}}</div>
                                    <div class="img-rating">
                                        <img :src="img1" v-if="item.rating == 1">
                                        <img :src="img2" v-if="item.rating == 2">
                                        <img :src="img3" v-if="item.rating == 3">
                                        <img :src="img4" v-if="item.rating == 4">
                                        <img :src="img5" v-if="item.rating == 5">
                                    </div><br /><!--{{item.slug}}-->
                                    
                                </div>
                            </v-card-title>  

                            <v-card-actions>
                                <v-btn v-if="slugAutor == slugLogado" class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn>
                                <!--v-btn class="release" flat color="orange" flat="flat" @click="displayItem(item.slug)">Perfil</v-btn-->
                            </v-card-actions>
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>
                
            

                
            
        </v-layout>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deletar resumo diário?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Resumo diário deletado com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties, usersData } from '@/global.js'

import img1 from '../assets/muito-feliz.png';
import img2 from '../assets/feliz.png';
import img3 from '../assets/normal.png';
import img4 from '../assets/ruim.png';
import img5 from '../assets/muito-ruim.png';

import lixeira from '../assets/ic-lixeira.png';

export default {
    name: 'Resumo-Diario-Listagem',
    data: vm => ({
        img1: img1,
        img2: img2,
        img3: img3,
        img4: img4,
        img5: img5,
        lixeira: lixeira,
        slug : null,
        slugAutor: null,
        slugLogado : null,
        dialogDeleteConfirm: false,
        dialog: false,
        loading: false,
        perfil: userProperties.perfil,
        menu: false,
        modalMessage: 'Resumo Diário excluído com sucesso!',
        items: [],
        date: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    }),
    methods: {
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        carregaDados() {

            var that = this;

            this.items = []
            this.loading = true
            let obj = []

            // timestamp - data atual
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var customtimestamp = year + month + day + hour + minute + second
            
            var dataAtual = year + "-" + month + "-" + day;

            var imagemAtual = null;
            
            db.collection("resumodiario_"+userProperties.escolaID).where("date", "==", dataAtual)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data()); 
                    let customObj = doc.data()    
                    if(userProperties.perfil == 4 || userProperties.perfil == 5){
                        // Filtro para exibir somente aluno da turma do professor logado                        
                        usersData.slugUsuariosPorTurma.forEach(function(item, index){
                            
                            if(item == customObj.aluno.alunoSlug){
                                if(that.$route.query.slugAluno == undefined || that.$route.query.slugAluno == customObj.aluno.alunoSlug){
                                    // busco dados do aluno pelo slug para montar imagem, nome etc...
                                    usersData.usuarios.forEach(function(item3, index3){
                                        if(item3.slug == customObj.aluno.alunoSlug){

                                            // recupera imagem do firebase storage
                                            var storageRef = firebase.storage().ref();
                                            var tangRef = storageRef.child('profile/'+item3.slug+'.'+item3.extensao);

                                            // First we sign in the user anonymously
                                            //firebase.auth().signInAnonymously().then((result) => {
                                            // Once the sign in completed, we get the download URL of the image
                                            tangRef.getDownloadURL().then(urlImgFB =>                             {
                                            // Once we have the download URL, we set it to our img element
                                            //console.log(urlImgFB);
                                            that.items.push({"imagem":urlImgFB, "nome":item3.nome, "entrada": customObj.entrada, "saida": customObj.saida, "rating": customObj.rating, "alunoSlug": customObj.aluno.alunoSlug, "slug": customObj.slug});


                                            }).catch(function(error) {
                                                // If anything goes wrong while getting the download URL, log the error,
                                                console.error(error);
                                            });
                                        }
                                    });
                                    
                                }
                            }
                        });
                        console.log("ZZZZZZZZZZZZZZZZZ");
                        console.log(that.items);
                    }
                    else{
                        //
                        if(that.$route.query.slugAluno == undefined || that.$route.query.slugAluno == customObj.aluno.alunoSlug){
                            that.items.push({"data":customObj.date, "texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "nome": customObj.nome, "alunoSlug": customObj.aluno.alunoSlug, "slug": customObj.slug, "slugAutor": customObj.slugAutor});
                        }
                    }
                    
                    
                    
                    
                    this.slug = customObj.slug;
                    this.slugAutor = customObj.slugAutor;
                    this.loading = false

                      
                    
                });
            });
            console.log(this.items);

        },
        save(){
            this.menu = false;
            var that = this;
            this.loading = true;

            that.items = [];

            db.collection("resumodiario_"+userProperties.escolaID).where("date", "==", this.date)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size != 0){

                    querySnapshot.forEach(doc => {
                        
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data()); 
                        let customObj = doc.data()    
                        if(userProperties.perfil == 4 || userProperties.perfil == 5){
                            // Filtro para exibir somente aluno da turma do professor logado
                            
                            usersData.slugUsuariosPorTurma.forEach(function(item, index){
                                console.log(item + "==" + customObj.aluno.alunoSlug)
                                if(item == customObj.aluno.alunoSlug){
                                    if(that.$route.query.slugAluno == undefined || that.$route.query.slugAluno == customObj.aluno.alunoSlug){
                                        that.items.push({"data":customObj.date, "texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "nome": customObj.nome, "alunoSlug": customObj.aluno.alunoSlug, "slug": customObj.slug, "slugAutor": customObj.slugAutor});
                                    }
                                }
                            });
                        }
                        else{
                            //
                            if(that.$route.query.slugAluno == undefined || that.$route.query.slugAluno == customObj.aluno.alunoSlug){
                                that.items.push({"data":customObj.date, "texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "nome": customObj.nome, "alunoSlug": customObj.aluno.alunoSlug, "slug": customObj.slug, "slugAutor": customObj.slugAutor});
                            }
                        }
                        
                        
                        
                        
                        this.slug = customObj.slug;
                        this.slugAutor = customObj.slugAutor;
                        this.loading = false

                        
                        
                    });
                }
                else{
                    this.loading = false;
                    alert("Não há registros no dia selecionado!");
                }
            });
        },
        editarItem(slug){
            this.$router.push(`/editar-diario/?slug=`+slug)

        },
        displayItem(slug){
            this.$router.push(`/xxx/?slug=`+slug)

        },
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection("resumodiario_"+userProperties.escolaID).where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
                this.dialogDeleteConfirm = false;
                this.carregaDados();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        }
        
            
        
    },
    created() {
        this.slugLogado = userProperties.slug;
        this.carregaDados();
    }
};



</script>

<style scoped>
    .loading{
        position: fixed;
        top:20%;
        left:41%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:absolute;
        right: 12px;
        display: none;
    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 12px;
    }

    .imagem{
        width: 80px;
        height: 80px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top: -8px;
    }

    .instagram{
        position: absolute;
        left: 15px;
    }

    .buttonOk{
        position: absolute;
        right: 2px;
        bottom: 5px;
    }

    .v-card__actions{
        height: 20px;
    }

    .v-menu{
        margin-left: 20px;
    }

    .img-rating img{
        width: 30px;
        height: auto;
        margin-top: 4px;
    }

    .lixeira{
        margin-top: 5px;
    }
</style>
